module.exports = {
  language: 'English',
  applierApplicationCenter: {
    selectCenterTip: 'Select this centre'
  },
  multiplePage: {
    moreInfomation: 'More information',
    recommendedServices: 'Recommended Services'
  },
  checkoutConfirm: {
    ordered: 'Ordered',
    purchased: 'Purchased'
  },
  personal: {
    purgePopupContent: 'Sorry, your application has been purged due to security policy, you may contact us if you want to apply soon.'
  },
  login_maximum: {
    errorContent: 'Sorry you have reached the maximum login times today, please try the next day.'
  },
  nationalityKay: 'en-us',
  noneSelectedText: 'Please select',
  multiselect: {
    deselect: 'Press enter to remove',
    select: 'Press enter to select',
    selected: 'Selected'
  },
  enter: 'Enter',
  upload_failed: 'Upload failed, please retry',
  due_time: 'Due time',
  requirement: 'Requirement',
  something_went_wrong_please_retry: 'Something went wrong, please retry',
  valid_rediret_home_page_popup_content:
    "Login exception occurred. Are you trying to go to [ {country} - {center} ] homepage to log in? If yes, please click on 'Confirm'; if no, please click 'Cancel' to select again.",
  invalid_rediret_home_page_popup_content: 'Login exception occurred, please select the country and location to proceed.',
  'Temporarily not available': 'Temporarily not available',
  'Coming soon': 'Coming soon'
};
